//import 'bootstrap';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';


// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js